import React from 'react';
import styled from 'styled-components';

interface BarraInferiorBotoesProps {
  children?: React.ReactNode;
}

const Container = styled.div`
  display: flex;
  align-self: end;
  align-items: end;
  justify-content: end;
  margin-left: auto;
  width: 100%;
  height: auto;
  background: #ffffff 0% 0% no-repeat padding-box;
  padding: 1vh;
  position: sticky;
  bottom: 0;
`;

const BarraInferiorBotoes: React.FC<BarraInferiorBotoesProps> = ({
  children,
}) => {
  return <Container>{children}</Container>;
};

export default BarraInferiorBotoes;
